import { render } from "./DTCarousel.vue?vue&type=template&id=78672edf&scoped=true"
import script from "./DTCarousel.vue?vue&type=script&lang=js"
export * from "./DTCarousel.vue?vue&type=script&lang=js"

import "./DTCarousel.vue?vue&type=style&index=0&id=78672edf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78672edf"]])

export default __exports__